import React from 'react';

const Confirm = () => {
  return (
    <div id="confirm">
      <h1> Congratualtions! Your order is on its way!</h1>
    </div>
  );
};
export default Confirm;
